import React, { Component } from 'react';
import config from 'react-global-configuration';
// Importação do Router
import { Link } from 'react-router-dom';
// Importação da tabela
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';


class EmailTrainingAttendenceConfirmation extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      message: '',
    };
    // Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.loadData = this.loadData.bind(this);

    this.locale = getLocale();
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    this.handleAlert('', '', 'open');
    fetch(config.get('api') + '/email/confirmacao/'+this.props.match.params.token, { method: 'GET', mode: 'cors', headers: headers }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      this.setState({message: responseJson.message});
      this.handleAlert('', '', 'closed');
    }).catch((error) => {
      console.error(error);
    });
  }

  render() {
    return (
<div className="user-wrapper" style={{backgroundImage: "url('" + config.get('cdn') + "/images/modal_background.png'), url('" + config.get('cdn') + "/images/fundo-login.jpg')"}}>
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="user-layer-suspended">
    <div className="container-liquid">
      <div className="row">
  			<div className="col-md-4 col-md-offset-4">
  				<div className="user-content text-center">
            <img src={config.get('cdn') + '/images/logo2.png'} alt="SIGVOOS" />
  					<h3>{this.state.message}</h3>
  					<br/>
            <p>
  			      <Link className={'btn btn-success'} to='/usuario/login'>
  			        <i className="fa fa-fw fa-refresh"></i> {this.locale.general.recarregar}
  			      </Link>
            </p>
  				</div>
  			</div>
      </div>
		</div>
  </div>
</div>
    );
  }
}

export default EmailTrainingAttendenceConfirmation;



// WEBPACK FOOTER //
// ./src/Components/Users/EmailTrainingAttendenceConfirmation.js